var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoftDevelopmentCase2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 475,
    height: 401,
    viewBox: "0 0 475 401",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.59 135.365C199.026 131.576 193.303 122.637 192.8 115.395C192.298 108.157 197.209 105.355 203.773 109.145C210.332 112.932 216.06 121.877 216.562 129.115C217.062 136.358 212.149 139.152 205.59 135.365Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.804 117.094L210.544 117.963L202.818 129.711L195.995 119.606L198.242 120.484L201.845 123.901L208.804 117.094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14.7621 350.932C22.9149 350.932 29.5241 344.332 29.5241 336.189C29.5241 328.047 22.9149 321.447 14.7621 321.447C6.6092 321.447 0 328.047 0 336.189C0 344.332 6.6092 350.932 14.7621 350.932Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.558 321.942C224.03 321.942 238.191 336.087 238.191 353.534C238.191 370.981 224.028 385.126 206.558 385.126C189.088 385.126 174.924 370.981 174.924 353.534C174.924 336.087 189.088 321.942 206.558 321.942ZM206.558 330.354C193.738 330.354 183.347 340.732 183.347 353.534C183.347 366.336 193.738 376.714 206.558 376.714C219.377 376.714 229.768 366.336 229.768 353.534C229.768 340.732 219.377 330.354 206.558 330.354Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.951 242.51C386.977 237.334 379.725 224.79 379.753 214.493C379.783 204.193 387.082 200.041 396.054 205.215C405.028 210.391 412.28 222.933 412.25 233.232C412.224 243.529 404.926 247.686 395.951 242.51ZM395.941 246.875C407.016 253.262 416.022 248.133 416.056 235.424C416.093 222.713 407.144 207.236 396.069 200.85C384.996 194.466 375.987 199.591 375.951 212.301C375.917 225.008 384.865 240.487 395.941 246.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M428.852 32.8151C434.916 32.8151 439.831 37.7244 439.831 43.7798C439.831 49.8353 434.916 54.7445 428.852 54.7445C422.789 54.7445 417.873 49.8353 417.873 43.7798C417.873 37.7244 422.789 32.8151 428.852 32.8151Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.743 75.803C135.22 75.803 143.714 84.2854 143.714 94.7485C143.714 105.212 135.22 113.692 124.743 113.692C114.267 113.692 105.773 105.209 105.773 94.7485C105.773 84.2854 114.267 75.803 124.743 75.803ZM124.743 80.8489C117.056 80.8489 110.826 87.073 110.826 94.7506C110.826 102.428 117.058 108.65 124.743 108.65C132.431 108.65 138.663 102.426 138.663 94.7506C138.661 87.0708 132.431 80.8489 124.743 80.8489Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.812 0C352.067 0 360.379 8.30089 360.379 18.542C360.379 28.7831 352.067 37.084 341.812 37.084C331.558 37.084 323.246 28.7831 323.246 18.542C323.246 8.30089 331.558 0 341.812 0ZM341.812 4.93699C334.289 4.93699 328.189 11.0287 328.189 18.542C328.189 26.0553 334.289 32.147 341.812 32.147C349.335 32.147 355.435 26.0553 355.435 18.542C355.435 11.0287 349.335 4.93699 341.812 4.93699Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M455.344 392.165L199.845 245.343C197.731 244.333 194.705 243.499 192.55 244.572C190.588 245.55 187.355 247.567 185.925 248.35C184.839 248.946 181.069 251.119 183.418 252.444C190.323 256.344 433.264 396.082 440.276 400.044C441.601 400.793 443.544 401.096 445.579 400.97C447.607 400.846 449.686 400.3 451.324 399.386C452.488 398.735 453.636 398.093 454.762 397.461C456.284 396.609 457.09 395.581 457.171 394.616C457.248 393.674 456.641 392.787 455.344 392.165Z",
    fill: "#4AABBE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M455.408 141.548C466.408 147.877 475.034 163.192 475 175.439L464.893 188.346L455.82 186.571C450.86 177.913 431.774 170.357 436.228 152.68L251.626 51.9612L195.882 14.0981C196.119 12.6723 194.378 5.63709 195.931 4.69793C197.665 3.64778 199.377 2.59763 201.078 1.60084C205.434 -0.971179 210.984 0.618989 215.062 2.96689L455.408 141.548Z",
    fill: "#DDEBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M474.532 383.909C474.515 390.093 472.324 394.447 468.793 396.494L463.769 399.512C442.943 389.739 451.219 297.428 449.919 266.771L455.82 186.568L475 175.437L474.532 383.909Z",
    fill: "#D0E7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.227 17.2656C190.261 4.81747 199.09 -0.219842 209.948 6.04265L450.293 144.622C461.138 150.878 469.92 166.065 469.885 178.515L469.42 386.985C469.383 399.431 460.546 404.462 449.697 398.208L209.351 259.627C198.492 253.364 189.723 238.182 189.759 225.736L190.227 17.2656Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.227 17.2656C190.261 4.81747 199.09 -0.219842 209.947 6.04265L230.074 17.6477L229.503 271.247L209.351 259.627C198.492 253.364 189.723 238.182 189.757 225.736L190.227 17.2656Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.639 12.9518C192.501 3.73314 200.447 0.561339 209.947 6.04048L450.293 144.62C459.783 150.093 467.691 162.404 469.497 173.736L190.639 12.9518Z",
    fill: "#F2F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.63 20.8237C220.01 19.8888 218.695 20.6402 218.689 22.4971C218.685 24.3563 219.99 26.6166 221.611 27.5515C223.228 28.4843 224.545 27.7351 224.551 25.876C224.558 24.019 223.25 21.7565 221.63 20.8237Z",
    fill: "#7980FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.948 14.5122C210.328 13.5794 209.014 14.3286 209.007 16.1856C209.003 18.0447 210.309 20.3072 211.929 21.24C213.547 22.1727 214.863 21.4235 214.868 19.5644C214.874 17.7074 213.566 15.4449 211.948 14.5122Z",
    fill: "#7980FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.078 9.2187C201.458 8.28594 200.144 9.03513 200.137 10.8921C200.131 12.7512 201.439 15.0137 203.059 15.9465C204.677 16.8793 205.994 16.1301 206 14.271C206.006 12.414 204.696 10.1515 203.078 9.2187Z",
    fill: "#7980FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.873 70.4776C202.294 65.5235 194.809 53.8416 194.153 44.3732C193.497 34.9111 199.915 31.2484 208.496 36.2025C217.071 41.1523 224.56 52.8448 225.214 62.3069C225.872 71.7732 219.448 75.4274 210.873 70.4776ZM210.687 67.7817C217.913 71.9546 223.327 68.8746 222.773 60.896C222.222 52.9217 215.911 43.069 208.684 38.8962C201.454 34.7212 196.042 37.8076 196.596 45.7819C197.15 53.7605 203.457 63.6067 210.687 67.7817Z",
    fill: "#E0EBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.205 66.1617C348.211 63.9376 349.789 63.039 351.727 64.1575C372.273 75.9247 392.773 88.1082 413.321 99.8754C415.257 100.992 416.826 103.705 416.819 105.929L416.92 187.151C416.914 189.373 415.334 190.272 413.398 189.155C392.852 177.386 372.347 165.203 351.804 153.437C349.865 152.319 348.299 149.608 348.305 147.384L348.205 66.1617Z",
    fill: "#C2DCF6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M348.643 64.5096L350.254 63.658C350.819 63.4723 351.533 63.5769 352.311 64.0208C371.599 75.0688 390.85 86.5073 410.141 97.5574C411.959 98.6054 413.432 101.152 413.426 103.239L413.52 179.499C413.518 180.447 413.21 181.138 412.703 181.512C412.096 181.96 410.844 182.933 409.852 182.359C390.561 171.309 371.67 158.891 352.383 147.843C350.562 146.793 349.092 144.249 349.098 142.161L348.643 64.5096Z",
    fill: "#F2F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M347.662 66.6313C347.668 64.5438 349.15 63.6985 350.968 64.7487C370.257 75.7966 389.507 87.2351 408.798 98.2852C410.617 99.3354 412.09 101.882 412.083 103.967L412.177 180.227C412.171 182.314 410.69 183.158 408.871 182.107C389.582 171.057 370.33 159.619 351.043 148.571C349.222 147.521 347.752 144.974 347.758 142.889L347.662 66.6313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M347.662 66.6313C347.668 64.5438 349.147 63.6985 350.968 64.7487C370.257 75.7966 389.507 87.2352 408.798 98.2852C410.617 99.3333 412.09 101.88 412.083 103.967L412.152 163.892L347.73 126.992L347.662 66.6313Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.418 67.882C360.761 70.3858 365.102 72.9044 369.441 75.4316V139.429L356.418 131.969V67.882Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M352.447 135.049C352.449 134.148 353.088 133.794 353.875 134.259L371.64 144.285C372.424 144.75 373.061 145.862 373.059 146.763V148.545C373.057 149.446 372.416 149.8 371.631 149.335L353.866 139.309C353.08 138.844 352.445 137.734 352.447 136.831V135.049Z",
    fill: "#40AEF6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M352.447 142.87C352.449 142.076 353.012 141.764 353.706 142.174C363.779 147.858 380.285 157.136 390.358 162.82C391.05 163.23 391.61 164.21 391.608 165.004V166.575C391.606 167.369 391.042 167.681 390.349 167.271C380.277 161.587 363.77 152.308 353.698 146.624C353.005 146.214 352.445 145.235 352.447 144.441V142.87Z",
    fill: "#40AEF6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M379.163 120.58C380.747 123.09 382.11 127.82 382.645 129.444C383.478 131.971 384.312 134.573 385.406 136.998C386.276 138.925 387.537 141.243 389.43 142.332C390.828 143.136 392.361 143.435 393.897 142.84C395.477 142.227 396.541 140.883 397.541 139.587C397.992 139.002 398.277 138.793 398.514 138.818C398.967 138.868 399.882 140.466 400.112 140.865C400.544 141.604 400.972 142.439 401.284 143.194C401.895 144.673 403.105 148.466 403.611 149.984L403.769 150.462L407.381 152.47C407.484 152.53 408.288 152.863 408.512 152.795L407.937 150.955C407.18 148.449 405.71 143.931 404.688 141.523C403.893 139.651 402.502 136.573 400.771 135.079C399.956 134.377 398.946 133.975 397.838 134.18C396.308 134.464 395.308 135.785 394.417 136.942C394.237 137.175 394.058 137.408 393.872 137.636C393.496 138.099 392.869 138.838 392.288 139.036C391.88 139.175 391.469 139.004 391.115 138.801C389.221 137.713 387.02 130.498 386.331 128.413C385.496 125.877 384.658 123.267 383.559 120.834C382.685 118.896 381.418 116.571 379.516 115.474C378.622 114.96 377.624 114.733 376.615 115.019C375.196 115.423 374.305 116.676 373.681 117.931C373.059 119.179 372.61 120.563 372.168 121.886C371.787 123.019 371.405 124.219 370.892 125.299C370.766 125.566 370.317 126.432 370.02 126.616C369.966 126.599 369.896 126.56 369.862 126.541C368.605 125.824 367.135 122.644 366.577 121.363C365.149 118.08 364.021 114.556 362.98 111.132C362.204 108.584 361.477 106.02 360.748 103.459C360.323 101.963 359.9 100.464 359.457 98.9725C359.195 98.0846 358.925 97.1924 358.633 96.3108L363.371 97.5083L355.085 82.9662L350.372 94.2255L354.193 95.1903L354.689 96.5862C355.074 97.6705 355.41 98.7825 355.737 99.8882C356.173 101.359 356.589 102.836 357.008 104.311C357.771 107 358.536 109.687 359.355 112.362C360.462 115.976 361.672 119.69 363.215 123.143C364.236 125.433 365.914 128.782 368.169 130.069C369.131 130.618 370.204 130.859 371.285 130.533C372.738 130.095 373.66 128.808 374.307 127.517C374.953 126.232 375.414 124.81 375.872 123.446C376.229 122.381 376.585 121.265 377.056 120.242C377.75 118.656 378.216 119.081 379.163 120.58Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.725 72.723C266.732 70.3965 268.382 69.4552 270.41 70.6249C291.909 82.9407 313.365 95.6877 334.868 108.006C336.894 109.175 338.535 112.012 338.529 114.339L338.633 199.337C338.627 201.663 336.975 202.603 334.947 201.433C313.446 189.117 291.988 176.368 270.491 164.054C268.463 162.885 266.824 160.046 266.83 157.721L266.725 72.723Z",
    fill: "#C2DCF6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.403 72.3986L269.077 71.5149C269.663 71.3207 270.404 71.4295 271.212 71.8927C291.242 83.3654 311.23 95.2415 331.261 106.716C333.148 107.805 334.678 110.45 334.672 112.616L334.77 191.802C334.768 192.786 334.447 193.505 333.922 193.894C333.291 194.359 331.992 195.369 330.961 194.775C310.931 183.301 291.313 170.406 271.285 158.934C269.393 157.843 267.867 155.2 267.874 153.034L267.403 72.3986Z",
    fill: "#F2F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.384 74.6013C266.39 72.4349 267.927 71.5555 269.819 72.6462C289.849 84.1189 309.837 95.995 329.869 107.47C331.756 108.558 333.287 111.203 333.28 113.372L333.379 192.558C333.372 194.724 331.833 195.599 329.944 194.511C309.914 183.036 289.922 171.158 269.896 159.687C268.004 158.596 266.478 155.954 266.484 153.785L266.384 74.6013Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.386 74.6013C266.393 72.4327 267.929 71.5555 269.819 72.6462C289.849 84.1189 309.837 95.995 329.869 107.47C331.756 108.558 333.287 111.203 333.28 113.372L333.351 175.597L266.457 137.28L266.386 74.6013Z",
    fill: "url(#paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.353 145.647C271.355 144.712 272.02 144.342 272.836 144.827L291.285 155.237C292.102 155.721 292.76 156.874 292.758 157.811V159.664C292.756 160.599 292.091 160.966 291.275 160.483L272.826 150.074C272.009 149.589 271.351 148.436 271.353 147.501V145.647Z",
    fill: "#03C8DE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.353 153.768C271.355 152.944 271.941 152.62 272.659 153.047C283.119 158.949 300.26 168.584 310.717 174.485C311.435 174.912 312.017 175.928 312.015 176.752V178.383C312.012 179.207 311.427 179.531 310.709 179.104C300.249 173.202 283.108 163.568 272.65 157.666C271.93 157.239 271.351 156.223 271.353 155.399V153.768Z",
    fill: "#03C8DE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M318.879 125.568L318.809 164.916L329.867 171.354L329.938 132.005L318.879 125.568ZM285.673 94.2682L285.564 146.94L296.622 153.378L296.731 100.706L285.673 94.2682ZM302.237 112.938L302.153 156.594L313.211 163.032L313.295 119.374L302.237 112.938ZM269.049 97.9352L268.979 137.286L280.037 143.721L280.107 104.373L269.049 97.9352Z",
    fill: "#03C8DE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.919 113.351C268.607 113.06 268.632 112.608 268.974 112.343C269.316 112.079 269.846 112.1 270.158 112.39L280.635 122.189L285.709 124.347L296.59 122.132L303.194 114.907C303.478 114.595 304.006 114.54 304.372 114.781C304.444 114.83 304.506 114.888 304.556 114.949L320.083 131.592L329.547 133.923C330.008 133.91 330.395 134.215 330.412 134.608C330.427 135 330.068 135.331 329.606 135.344L319.734 133.026C319.467 133.041 319.196 132.945 319.018 132.751L303.855 116.505L297.736 123.201L297.733 123.199C297.62 123.323 297.46 123.417 297.267 123.455L285.801 125.79C285.617 125.829 285.416 125.812 285.235 125.735L279.8 123.423C279.688 123.385 279.584 123.325 279.498 123.244L268.919 113.351Z",
    fill: "#1895F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.919 113.557C268.607 113.216 268.632 112.686 268.974 112.375C269.316 112.063 269.846 112.089 270.158 112.43L280.635 123.931L285.709 126.464L296.59 123.862L303.194 115.382C303.478 115.017 304.006 114.951 304.372 115.235C304.444 115.293 304.506 115.359 304.556 115.431L319.275 134.398L329.666 134.012C330.128 133.995 330.517 134.355 330.532 134.816C330.549 135.278 330.188 135.664 329.726 135.681L318.931 136.082C318.664 136.099 318.392 135.986 318.215 135.76L303.859 117.261L297.74 125.12L297.738 125.117C297.624 125.263 297.464 125.371 297.272 125.418L285.805 128.161C285.621 128.206 285.421 128.187 285.239 128.095L279.804 125.38C279.693 125.335 279.588 125.265 279.503 125.169L268.919 113.557Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.096 291.744L277.13 291.182C277.194 291.895 277.237 292.294 277.256 292.32L199.434 246.495C198.864 246.158 198.718 245.17 198.742 244.577L193.429 183.505L193.444 183.514L192.448 172.065C192.454 171.188 193.279 170.133 193.491 169.937C194.301 170.799 197.07 172.69 200.531 174.906L200.447 107.762C200.456 105.039 202.386 103.937 204.763 105.308C229.933 119.726 255.052 134.65 280.225 149.07C282.597 150.439 284.519 153.762 284.512 156.485L284.574 206.129L290.304 209.347L284.626 247.682L284.636 255.996C284.632 257.58 283.974 258.615 282.959 258.933L278.096 291.744Z",
    fill: "#C2DCF6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.775 282.444L198.935 240.165L208.32 164.688C208.406 163.725 209.025 162.4 210.246 162.882L283.398 203.977L271.775 282.444Z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.321 164.688C240.444 198.483 277.13 219.497 276.173 248.579L271.776 282.444L198.915 240.391L208.321 164.688Z",
    fill: "#783FD3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.198 220.935L272.223 277.242L281.845 205.687C282.123 203.29 284.04 203.488 283.814 205.183L273.903 278.514C273.734 279.853 273.48 280.858 273.17 281.532C272.913 282.124 272.586 282.555 272.206 282.847L272.204 282.86L272.148 282.89C272.093 282.928 272.039 282.965 271.982 282.999L271.979 282.973C271.533 283.172 271.178 283.155 270.904 282.95C270.592 282.687 270.396 282.092 270.317 281.174L265.256 223.012C265.14 221.435 266.249 220.067 267.198 220.935Z",
    fill: "#864DE2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.05 104.603L201.052 103.545C201.753 103.314 202.64 103.442 203.606 103.995C227.576 117.724 251.496 131.937 275.467 145.668C277.726 146.972 279.556 150.135 279.55 152.729L279.667 247.492C279.665 248.67 279.28 249.531 278.652 249.994C277.897 250.551 276.342 251.759 275.11 251.048C251.139 237.317 227.663 221.885 203.698 208.156C201.435 206.852 199.61 203.689 199.616 201.096L199.05 104.603Z",
    fill: "#F2F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.831 107.241C197.84 104.648 199.678 103.598 201.941 104.902C225.911 118.631 249.831 132.844 273.802 146.575C276.062 147.879 277.891 151.043 277.885 153.636L278.002 248.397C277.996 250.991 276.153 252.039 273.892 250.734C249.923 237.003 225.998 222.79 202.031 209.061C199.768 207.757 197.942 204.594 197.949 202.001L197.831 107.241Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.479 120.112C211.747 120.974 214.668 124.838 215.008 128.737C215.346 132.639 212.971 135.1 209.706 134.238C206.438 133.376 203.516 129.512 203.176 125.613C202.836 121.711 205.211 119.25 208.479 120.112Z",
    fill: "#6D6AFD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.759 123.367C210.52 123.833 212.098 125.914 212.279 128.018C212.461 130.121 211.181 131.448 209.42 130.983C207.658 130.518 206.081 128.437 205.9 126.332C205.716 124.23 206.996 122.902 208.759 123.367Z",
    fill: "url(#paint11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.797 127.963C216.8 127.137 217.385 126.812 218.105 127.239L239.938 139.606C240.658 140.033 241.239 141.051 241.237 141.877V143.512C241.235 144.338 240.647 144.663 239.929 144.236L218.097 131.869C217.377 131.442 216.795 130.424 216.797 129.598V127.963Z",
    fill: "#6D6AFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.797 133.971C216.8 133.485 217.144 133.292 217.571 133.544L230.463 140.846C230.888 141.098 231.233 141.7 231.23 142.187V143.151C231.228 143.638 230.882 143.83 230.457 143.578L217.565 136.276C217.139 136.025 216.795 135.423 216.797 134.936V133.971Z",
    fill: "#6D6AFD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.499 189.166L224.391 166.248L231.408 191.695L238.536 183.029L247.418 210.312L210.499 189.166Z",
    fill: "url(#paint12_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.768 167.896C237.676 168.368 239.382 170.596 239.581 172.869C239.779 175.145 238.392 176.605 236.484 176.133C234.575 175.661 232.867 173.433 232.671 171.16C232.472 168.884 233.859 167.424 235.768 167.896Z",
    fill: "#FFDB59"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.833 149.941C202.841 146.492 205.288 145.096 208.295 146.831L252.934 172.112C255.939 173.845 258.371 178.052 258.363 181.501L258.232 218.306C258.224 221.755 255.775 223.149 252.77 221.416L208.131 196.137C205.122 194.402 202.694 190.195 202.702 186.748L202.833 149.941Z",
    fill: "url(#paint13_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.54 185.273C265.551 181.824 267.996 180.428 271.003 182.163L278.094 186.178L278.019 235.533L270.838 231.465C267.829 229.729 265.401 225.522 265.409 222.075L265.54 185.273Z",
    fill: "url(#paint14_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.435 221.735C266.846 226.83 270.755 282.703 270.975 282.994L196.867 239.357C196.325 239.035 196.186 238.096 196.209 237.53L191.15 179.372L191.163 179.381L190.214 168.478C190.221 167.644 191.005 166.638 191.208 166.453C193.583 168.98 213.643 180.788 216.163 182.35C220.198 185.902 219.446 190.553 225.163 197.953C226.257 199.37 226.657 199.735 228.174 200.679L266.435 221.735Z",
    fill: "url(#paint15_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.198 220.935L272.223 277.242L273.903 278.512C273.734 279.85 273.48 280.856 273.17 281.53C272.913 282.122 272.586 282.553 272.206 282.845L272.204 282.858L272.148 282.888C272.093 282.926 272.039 282.963 271.982 282.997L271.979 282.971C271.533 283.17 271.178 283.153 270.904 282.948C270.592 282.685 270.396 282.09 270.317 281.172L265.256 223.01C265.14 221.435 266.249 220.067 267.198 220.935Z",
    fill: "#864DE2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.401 198.699L267.258 220.869C266.431 220.459 265.211 222.032 265.258 223.008L227.892 200.82C226.843 200.18 226.189 199.808 225.308 199.025C221.048 195.236 219.745 189.838 217.321 185.535C216.631 184.31 215.861 183.461 215.06 182.778C214.278 182.336 213.863 182.101 214.004 182.171L190.212 168.458C190.229 167.627 190.922 166.112 192.411 166.165L216.233 179.898C216.092 179.828 216.507 180.063 217.289 180.504C218.09 181.187 218.86 182.037 219.55 183.262C222.115 187.815 223.231 192.903 228.01 197.14C228.693 197.742 229.621 198.223 230.401 198.699Z",
    fill: "#D477E4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.106 378.987L351.994 336.557C351.353 336.194 351.009 335.199 350.917 334.608L333.475 273.349L333.49 273.358L330.22 261.874C330.053 260.999 330.675 259.983 330.85 259.797C333.889 262.561 350.111 272.476 353.103 274.235C357.286 277.507 358.098 281.424 362.668 287.304L370.253 251.347L370.257 251.326V251.315L370.259 251.302L370.264 251.283V251.279L370.268 251.253L370.27 251.247L370.274 251.227L370.278 251.21L370.281 251.202L370.287 251.176V251.174L370.293 251.149L370.296 251.136L370.3 251.121L370.306 251.095L370.308 251.093L370.317 251.063L370.319 251.055L370.325 251.035L370.332 251.014L370.334 251.008L370.343 250.978V250.973L370.351 250.948L370.358 250.929L370.362 250.916L370.373 250.884L370.383 250.852L370.387 250.839L370.394 250.82L370.402 250.792L370.405 250.786L370.415 250.754L370.42 250.745L370.428 250.719L370.437 250.698L370.443 250.687L370.456 250.653V250.649L370.469 250.619L370.475 250.602L370.481 250.585L370.494 250.555L370.496 250.551L370.511 250.517L370.518 250.506L370.529 250.483L370.541 250.457L370.546 250.448L370.563 250.414L370.565 250.408L370.58 250.38L370.59 250.361L370.599 250.346L370.616 250.312L370.635 250.278L370.644 250.265L370.655 250.246L370.672 250.218L370.674 250.211L370.693 250.177L370.699 250.169L370.714 250.143L370.729 250.122L370.736 250.111L370.757 250.079L370.759 250.077L370.779 250.047L370.789 250.032L370.8 250.017L370.821 249.987L370.823 249.985L370.847 249.953L370.855 249.943L370.873 249.923L370.896 249.893L370.92 249.864L370.924 249.859L370.945 249.834L370.96 249.817L370.971 249.806L370.997 249.778L371.022 249.75L371.033 249.74L371.048 249.725L371.071 249.703L371.076 249.699L371.103 249.674L371.11 249.667L371.131 249.648L371.15 249.631L371.159 249.622L371.189 249.599L371.191 249.597L371.219 249.578L371.234 249.567L371.249 249.556L371.277 249.537L371.279 249.535L371.311 249.516L371.321 249.509L371.343 249.496C371.64 249.326 372.001 249.277 372.433 249.445L445.593 291.908H445.589C445.91 292.092 446.053 292.561 445.92 293.17L428.837 374.225C428.542 375.63 428.183 376.686 427.801 377.397C427.416 378.138 426.948 378.646 426.424 378.947C425.922 379.224 425.482 379.226 425.106 378.987Z",
    fill: "#C2DCF6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M421.566 365.828L352.031 325.472L368.173 248.952L368.178 248.931V248.922L368.18 248.909L368.184 248.89V248.886L368.188 248.862L368.19 248.856L368.195 248.839L368.199 248.822L368.201 248.813L368.207 248.788V248.786L368.214 248.762L368.216 248.749L368.22 248.737L368.227 248.713L368.229 248.711L368.235 248.683L368.237 248.675L368.244 248.655L368.25 248.634L368.252 248.628L368.261 248.598V248.594L368.269 248.568L368.276 248.551L368.28 248.538L368.289 248.508L368.299 248.478L368.304 248.465L368.31 248.448L368.319 248.423L368.321 248.419L368.331 248.386L368.336 248.378L368.344 248.354L368.353 248.333L368.357 248.322L368.37 248.29V248.288L368.383 248.258L368.389 248.241L368.396 248.224L368.408 248.194L368.41 248.192L368.425 248.16L368.43 248.15L368.44 248.128L368.451 248.103L368.455 248.094L368.472 248.062L368.475 248.056L368.487 248.028L368.496 248.009L368.502 247.996L368.519 247.964L368.537 247.932L368.543 247.919L368.554 247.9L368.569 247.874L368.571 247.868L368.59 247.836L368.594 247.827L368.609 247.804L368.622 247.782L368.628 247.772L368.648 247.74L368.65 247.738L368.669 247.71L368.68 247.695L368.69 247.68L368.71 247.652L368.712 247.65L368.733 247.62L368.74 247.612L368.755 247.592L368.778 247.563L368.802 247.535L368.806 247.531L368.825 247.507L368.838 247.492L368.849 247.481L368.874 247.454L368.9 247.428L368.911 247.417L368.926 247.403L368.947 247.381L368.951 247.377L368.977 247.353L368.983 247.347L369.005 247.33L369.024 247.315L369.032 247.309L369.06 247.287L369.062 247.285L369.088 247.266L369.103 247.255L369.118 247.245L369.146 247.225L369.148 247.223L369.178 247.204L369.188 247.198L369.21 247.187C369.492 247.025 369.836 246.978 370.246 247.138L439.776 287.494C437.502 286.241 428.254 343.265 421.566 365.828Z",
    fill: "url(#paint16_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.175 248.95C397.379 282.373 432.216 303.016 428.81 332.023L421.569 365.828L352.033 325.47L368.175 248.95Z",
    fill: "#E23B93"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M420.602 280.448L419.032 358.057L346.1 316.01L346.318 239.074L420.602 280.448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M419.247 281.123L420.771 280.239L420.553 357.178L419.029 358.057L419.247 281.123Z",
    fill: "#F2F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M346.318 239.074L347.849 238.188L420.772 280.239L419.248 281.123L346.318 239.074Z",
    fill: "#F2F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M416.469 341.408L416.454 346.262L348.953 307.34L348.968 302.491L416.469 341.408ZM416.621 285.626L416.614 290.478L349.113 251.558L349.128 246.709L416.621 285.626ZM416.597 293.59L349.105 254.67L349.09 259.52L416.582 298.437L416.597 293.59ZM416.576 301.562L349.075 262.643L349.068 267.494L416.561 306.412L416.576 301.562ZM416.554 309.532L349.053 270.613L349.038 275.462L416.539 314.382L416.554 309.532ZM416.533 317.5L349.032 278.581L349.017 283.432L416.518 322.352L416.533 317.5ZM416.512 325.472L349.011 286.553L348.996 291.404L416.497 330.324L416.512 325.472ZM416.49 333.442L348.989 294.523L348.974 299.372L416.475 338.292L416.49 333.442Z",
    fill: "#DAECFD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M402.754 310.213L419.331 368.428L419.333 368.43C419.555 369.03 420.023 369.929 420.354 370.283L350.823 329.931C350.214 329.585 349.887 328.642 349.799 328.081L333.223 269.861L333.238 269.87L330.13 258.956C329.972 258.124 330.562 257.159 330.728 256.982C333.616 259.609 349.034 269.031 351.877 270.704C356.638 274.431 356.801 279.031 364.014 286.67C365.395 288.132 365.869 288.516 367.583 289.524L402.754 310.213Z",
    fill: "url(#paint17_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M403.611 307.972C403.724 307.869 403.842 307.784 403.951 307.722C404.494 307.413 404.981 307.545 405.146 308.081L421.566 365.828L437.707 289.306C437.85 288.591 438.348 287.891 438.885 287.582C438.998 287.517 439.113 287.468 439.22 287.439C439.885 287.261 440.276 287.827 440.088 288.685L423.853 365.717C423.573 367.054 423.233 368.057 422.868 368.731C422.502 369.436 422.058 369.918 421.56 370.204C421.066 370.49 420.639 370.486 420.271 370.234C419.906 369.959 419.591 369.357 419.331 368.437L402.752 310.213C402.577 309.564 402.961 308.555 403.611 307.972Z",
    fill: "#E23B93"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.753 287.283L404.825 307.637C403.913 307.191 402.513 309.238 402.754 310.213L367.331 289.656C366.149 288.971 365.418 288.57 364.377 287.748C359.342 283.776 356.965 278.335 353.676 273.934C352.74 272.681 351.798 271.799 350.855 271.082C349.981 270.606 349.517 270.354 349.673 270.429L330.126 258.937C329.978 258.109 330.562 257.155 330.728 256.98C331.098 256.587 331.677 256.103 332.203 256.378L351.785 267.889C351.629 267.814 352.092 268.066 352.967 268.542C353.909 269.259 354.85 270.141 355.788 271.394C359.269 276.051 361.759 281.287 367.406 285.731C368.21 286.365 368.872 286.773 369.753 287.283Z",
    fill: "#FB84B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.028 304.045C373.106 305.609 379.101 312.61 380.418 319.684C381.734 326.755 377.872 331.22 371.794 329.656C365.715 328.091 359.72 321.09 358.404 314.017C357.087 306.945 360.949 302.48 367.028 304.045Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M365.339 314.164L365.143 311.891C365.004 310.523 365.173 309.635 365.641 309.176C366.203 308.625 367.015 308.681 368.083 309.27L370.4 310.501C371.524 311.048 372.206 311.72 372.653 312.649C373.068 313.517 373.243 314.563 373.38 315.942L373.542 317.586C374.025 318.45 374.38 319.376 374.553 320.307C375.141 323.47 373.414 325.466 370.697 324.766C367.979 324.066 365.299 320.935 364.711 317.773C364.42 316.237 364.683 314.975 365.339 314.164ZM371.958 315.451C371.843 314.465 371.698 313.707 371.422 313.131C371.135 312.531 370.667 312.087 369.879 311.707C369.09 311.332 368.299 310.834 367.511 310.45C367.038 310.19 366.748 310.096 366.652 310.19C366.463 310.375 366.414 310.928 366.51 311.891L366.632 313.302C367.19 313.135 367.842 313.131 368.564 313.317C369.761 313.624 370.952 314.405 371.958 315.451Z",
    fill: "url(#paint18_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.347 319.385L370.507 320.992C370.546 321.37 370.268 321.675 369.89 321.675C369.511 321.675 369.174 321.37 369.137 320.992L368.926 318.86C368.663 318.561 368.464 318.185 368.393 317.807C368.257 317.073 368.656 316.61 369.289 316.772C369.919 316.934 370.541 317.662 370.678 318.394C370.766 318.87 370.629 319.233 370.347 319.385Z",
    fill: "#21389B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M387.297 159.787C387.312 154.603 390.989 152.507 395.509 155.113L453.497 188.677C458.013 191.281 461.67 197.608 461.655 202.79L461.649 233.482C461.634 238.664 457.953 240.76 453.435 238.156L395.447 204.592C390.924 201.983 387.274 195.661 387.289 190.479L387.297 159.787Z",
    fill: "#C2DCF6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M388.026 159.053C388.031 157.294 387.409 156.204 388.163 155.243C388.644 154.633 390.313 153.89 391.021 153.647C392.388 153.173 394.126 153.418 396.013 154.507L450.592 186.242C454.985 188.775 458.541 194.927 458.528 199.969L458.338 225.275C458.334 226.837 458.007 228.839 456.806 229.936C455.951 230.718 454.452 231.501 453.337 231.593C452.193 231.687 451.751 230.63 450.349 229.821L395.772 198.086C391.373 195.55 387.821 189.401 387.836 184.359L388.026 159.053Z",
    fill: "#F2F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.755 159.801C386.77 154.759 390.343 152.719 394.742 155.254L449.321 186.989C453.713 189.523 457.27 195.675 457.257 200.716L457.067 226.022C457.052 231.064 453.472 233.102 449.08 230.569L394.502 198.834C390.104 196.298 386.552 190.148 386.567 185.107L386.755 159.801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M386.582 159.815C386.597 154.759 390.181 152.641 394.59 155.186L449.308 186.982C453.903 189.522 457.267 195.776 457.252 200.831L457.235 205.618L386.562 164.665L386.582 159.815Z",
    fill: "url(#paint19_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M393.363 160.238C394.321 160.492 395.175 161.623 395.276 162.765C395.374 163.907 394.68 164.628 393.722 164.377C392.765 164.123 391.91 162.993 391.809 161.849C391.711 160.705 392.406 159.984 393.363 160.238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M398.725 163.489C399.683 163.74 400.538 164.872 400.638 166.016C400.737 167.158 400.042 167.879 399.085 167.627C398.127 167.373 397.272 166.244 397.172 165.1C397.071 163.956 397.768 163.235 398.725 163.489Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M404.086 166.739C405.043 166.993 405.898 168.122 405.999 169.267C406.097 170.408 405.402 171.13 404.445 170.878C403.487 170.626 402.632 169.495 402.532 168.351C402.434 167.207 403.128 166.485 404.086 166.739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M397.879 175.294C403.201 176.701 407.963 182.991 408.514 189.345C409.066 195.7 405.197 199.71 399.875 198.306C394.554 196.899 389.792 190.609 389.24 184.255C388.689 177.9 392.555 173.888 397.879 175.294Z",
    fill: "#6D6AFD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M398.339 180.596C401.209 181.354 403.776 184.746 404.073 188.171C404.37 191.597 402.284 193.759 399.416 193.002C396.545 192.244 393.979 188.852 393.681 185.427C393.382 182.001 395.468 179.839 398.339 180.596Z",
    fill: "url(#paint20_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M411.434 188.082C411.438 186.737 412.391 186.208 413.564 186.904L449.131 207.051C450.304 207.747 451.253 209.403 451.249 210.75V213.411C451.244 214.756 450.289 215.285 449.118 214.59L413.552 194.442C412.378 193.747 411.429 192.088 411.434 190.743V188.082Z",
    fill: "#6D6AFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M411.434 197.872C411.436 197.078 412 196.765 412.692 197.177L433.693 209.074C434.386 209.486 434.946 210.464 434.944 211.258V212.829C434.941 213.623 434.377 213.934 433.685 213.524L412.684 201.629C411.991 201.217 411.431 200.24 411.434 199.446V197.872Z",
    fill: "#6D6AFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M441.977 189.721C441.979 189.219 442.334 189.017 442.77 189.269L450.355 193.341C450.791 193.593 451.144 194.203 451.144 194.705V196.568C451.142 197.07 450.787 197.271 450.351 197.021L442.766 192.948C442.33 192.696 441.977 192.086 441.977 191.584V189.721Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.5403 352.36L127.588 330.151C131.846 328.209 137.937 326.663 142.275 328.917C146.227 330.971 152.737 335.176 155.614 336.813C157.8 338.059 165.39 342.599 160.662 345.167C146.757 352.719 132.995 361.212 118.874 368.883C116.203 370.334 112.298 370.857 108.197 370.518C104.115 370.179 99.9255 368.992 96.632 367.077C94.2853 365.713 91.9771 364.373 89.7073 363.052C86.6446 361.269 85.0203 359.165 84.86 357.218C84.7039 355.314 85.9265 353.551 88.5403 352.36Z",
    fill: "#4AABBE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.025 350.027C103.909 350.008 106.893 347.207 109.718 348.62C113.112 350.319 119.556 348.815 122.807 349.594C123.386 349.733 124.519 349.308 124.743 349.705C125.444 350.949 126.122 352.81 124.399 354.027C123.132 354.924 120.418 356.108 118.637 356.738C116.748 357.406 113.514 358.46 111.347 358.8C108.947 359.175 107.851 359.329 106.953 360.023C105.668 360.669 104.341 360.947 103.602 360.827C102.018 360.576 100.173 359.649 99.3271 357.848C99.0578 357.271 99.0492 354.755 99.3591 353.122C99.6049 351.835 100.308 350.366 100.87 348.996L103.025 350.027Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.966 344.004C108.894 346.578 109.223 350.561 106.679 351.944C104.978 352.868 102.315 352.877 101.154 350.236C100.507 348.763 101.366 346.249 101.176 343.018L109.966 344.004Z",
    fill: "#FFA495"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.674 347.991C112.623 348.556 118.005 348.179 121.409 348.454C122.871 348.571 124.183 348.561 124.867 349.888C125.496 351.109 125.167 352.153 123.741 353.16C122.474 354.057 120.324 355.077 118.541 355.707C116.652 356.375 113.418 357.429 111.251 357.767C108.851 358.142 107.754 358.296 106.857 358.99C105.572 359.636 104.245 359.914 103.505 359.794C101.922 359.543 100.077 358.428 99.2309 356.627C98.9617 356.051 98.9531 353.722 99.2651 352.089C99.325 351.777 99.4105 351.455 99.5152 351.128C99.7824 348.571 100.629 347.536 101.426 347.974C102.518 348.574 102.928 349.651 103.345 350.537C103.698 351.289 104.224 351.758 104.828 351.95C106.134 352.362 107.325 351.634 108.096 350.516C108.528 349.767 108.782 348.864 108.992 347.925C108.996 347.837 108.996 347.75 108.996 347.664C109.253 345.429 110.34 345.624 110.176 346.095C110.022 346.529 110.084 347.536 110.674 347.991Z",
    fill: "#193161"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.186 349.511C124.16 350.375 125.485 350.456 125.102 351.976C125.739 351.353 124.85 349.56 124.457 349.289C124.297 349.175 124.158 349.131 124.186 349.511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.203 341.165C126.026 340.842 127.864 337.188 131.003 337.545C132.271 337.688 134.308 337.359 136.374 336.772C139.67 335.835 144.263 332.894 145.047 333.374C146.755 334.424 146.892 336.337 145.693 338.072C144.81 339.348 143.143 341.047 141.688 342.251C140.145 343.528 137.954 345.481 136.037 346.544C134.224 347.549 133.622 347.459 132.331 349.201C131.348 350.249 130.198 350.872 129.46 351.015C127.575 351.382 124.84 350.174 123.854 348.913C123.228 346.887 122.14 344.973 122.837 341.933L125.203 341.165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.557 332.542C129.505 335.329 131.279 338.913 129.422 341.133C128.18 342.616 125.707 343.602 123.656 341.575C122.512 340.443 122.386 337.788 121.018 334.853L129.557 332.542Z",
    fill: "#FFA495"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.53 335.94C135.718 335.891 135.906 335.839 136.094 335.786C139.39 334.851 143.795 332.582 144.579 333.065C146.287 334.113 146.612 335.353 145.413 337.088C144.53 338.364 142.863 340.063 141.408 341.267C139.865 342.544 137.674 344.497 135.757 345.56C133.944 346.565 133.342 346.475 132.053 348.217C131.07 349.265 129.918 349.888 129.183 350.031C127.297 350.398 124.478 349.18 123.493 347.918C123.027 346.411 122.388 344.975 122.337 343.082C122.063 340.601 122.234 339.342 123.314 339.372C125.323 339.43 126.152 340.488 126.981 341.005C128.768 342.117 129.965 340.68 130.258 338.9C130.311 338.155 130.223 337.357 130.095 336.55C130.067 336.467 130.035 336.386 130.003 336.307C129.418 334.134 130.503 333.916 130.523 334.414C130.567 335.543 131.273 336.177 132.181 336.311C133.267 336.471 134.645 336.017 135.53 335.94Z",
    fill: "#193161"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.374 333.342C144.725 334.134 145.956 333.637 146.266 335.171C146.571 334.332 144.996 333.101 144.524 333.024C144.329 332.992 144.186 333.009 144.374 333.342Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.116 235.149C98.6731 242.745 98.7714 243.336 111.578 250.85L114.014 246.06C109.716 237.27 108.432 236.101 102.851 229.257C107.925 225.751 113.377 220.395 115.976 216.929C124.329 205.796 119.691 198.058 112.476 199.627C106.181 200.993 96.3628 217.264 91.0239 226.438C88.7969 230.261 88.2561 230.679 92.116 235.149Z",
    fill: "url(#paint21_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.008 227.676C109.402 224.28 113.741 219.906 115.974 216.929C124.327 205.796 119.447 198.282 112.23 199.849C108.466 200.999 101.751 208.955 105.008 227.676Z",
    fill: "#17ACC8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.659 257.242C128.381 265.321 132.435 291.123 131.307 298.207C129.612 308.858 130.095 321.726 130.114 333.03C129.828 337.782 123.288 340.262 121.386 337.244C119.858 327.144 117.682 318.292 116.799 312.678C115.81 306.392 116.137 298.755 117.733 294.623C117.079 290.111 113.997 278.467 111.422 270.399C110.492 267.488 105.23 258.081 110.678 248.732L127.659 257.242Z",
    fill: "url(#paint22_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.221 329.997C130.228 330.836 130.196 332.113 130.198 332.936C129.911 337.688 123.29 340.262 121.386 337.244C121.273 336.499 121.11 335.763 120.99 335.033C123.551 337.786 128.567 334.207 130.221 329.997Z",
    fill: "url(#paint23_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.482 293.398C129.349 304.079 123.318 318.348 120.026 329.088C118.312 319.886 114.023 304.215 117.733 294.623C117.359 292.053 116.199 287.17 114.794 281.953C117.648 276.548 114.921 272.237 116.269 264.628C123.824 263.313 112.422 254.103 128.411 263.804C129.839 275.264 131.181 282.472 131.482 293.398Z",
    fill: "#1E2353"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.138 303.53C122.78 313.385 114.737 332.717 110.461 344.81C108.249 348.023 100.358 347.688 100.373 344.691C102.115 334.58 104.162 318.984 107.798 310.115C108.911 307.4 113.015 300.868 114.494 298.932C115.644 294.469 117.084 282.416 118.198 275.893C117.2 270.495 112.842 261.473 121.215 253.629C124.594 256.028 135.044 257.53 139.78 254.858C140.543 276.177 135.302 285.067 127.138 303.53Z",
    fill: "url(#paint24_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.345 342.702C111.155 343.229 110.774 344.298 110.597 344.804C108.319 348.11 100.197 347.767 100.212 344.682C100.297 344.183 100.385 343.671 100.473 343.146C102.407 345.116 108.265 345.143 111.345 342.702Z",
    fill: "url(#paint25_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.663 228.265C109.366 234.598 107.459 240.826 109.4 246.608C109.488 247.206 109.541 249.55 109.644 250.188C110.922 257.678 126.787 265.257 140.016 258.07C140.089 257.142 140.006 256.171 140.076 254.45C139.833 252.843 140.527 251.123 140.521 250.143C140.501 246.068 139.232 243.983 139.841 239.447C141.081 230.22 146.199 221.351 143.368 214.092C142.761 212.534 141.696 211.778 140.489 210.812C137.362 208.304 121.191 200.079 116.288 199.499C102.059 197.655 107.9 221.394 108.663 228.265Z",
    fill: "url(#paint26_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.28 199.431C135.381 199.875 130.813 199.23 130.946 199.638C131.012 201.678 131.619 202.918 131.818 205.714C126.795 205.014 120.206 204.289 119.943 200.442C119.964 200.135 119.982 199.826 119.994 199.525C120.001 199.488 120.005 199.454 120.012 199.418L119.999 199.416C120.052 198.018 119.986 196.752 119.595 196.12C118.53 194.402 116.346 192.489 115.57 189.885C114.333 185.725 114.784 181.102 118.667 178.02C125.763 172.393 134.833 176.398 137.133 184.626C137.582 186.233 136.312 187.104 136.357 188.477C136.366 188.746 136.723 189.025 137.011 189.623C137.415 190.449 137.383 198.886 136.28 199.431Z",
    fill: "#E7A376"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.233 199.384C135.334 199.828 130.813 199.228 130.946 199.638C131.012 201.678 131.619 202.918 131.818 205.715C128.9 206.43 121.035 205.382 119.858 200.963C119.836 200.033 119.879 196.577 119.595 196.122C118.53 194.404 116.346 192.492 115.57 189.888C114.333 185.727 114.784 181.104 118.667 178.022C125.763 172.396 134.833 176.4 137.133 184.628C137.582 186.235 136.312 187.106 136.357 188.479C136.366 188.748 136.723 189.027 137.011 189.625C137.415 190.449 137.336 198.839 136.233 199.384Z",
    fill: "url(#paint27_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.094 199.431C135.618 199.687 133.645 199.518 132.177 198.955C131.251 198.598 130.58 197.806 130.437 197.749C129.828 197.503 128.477 195.589 130.572 192.538C132.613 189.565 120.251 197.177 119.597 196.12C118.533 194.404 116.348 192.489 115.572 189.885C114.335 185.725 114.786 181.102 118.669 178.02C125.765 172.393 134.836 176.398 137.135 184.626C137.584 186.233 136.315 187.104 136.359 188.477C136.368 188.746 136.725 189.025 137.013 189.623C137.415 190.449 137.178 198.85 136.094 199.431Z",
    fill: "url(#paint28_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.01 192.628C128.467 190.261 126.015 197.789 130.104 197.71C128.509 196.022 129.721 193.35 131.01 192.628Z",
    fill: "#FFA698"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.997 193.727C131.377 192.675 131.057 192.291 130.593 192.406C130.084 192.532 129.36 193.262 128.984 194.353C128.377 196.112 129.247 198.334 130.948 197.467C129.484 197.552 129.621 195.789 130.061 194.703C130.36 193.964 130.82 193.441 130.997 193.727Z",
    fill: "#FFB49C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.326 194.203C130.734 194.963 130.877 195.416 130.745 195.678C130.653 195.86 130.371 196.067 129.909 195.621C129.896 195.093 130.082 194.605 130.326 194.203Z",
    fill: "#FFA698"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.528 182.703L133.626 182.652C137.041 180.833 136.503 177.07 135.06 175.792C132.273 173.322 124.713 173.58 119.92 176.046C115.04 178.556 113.843 184.799 115.303 189.706C116.273 192.972 118.635 194.677 119.817 197.151C120.469 197.99 121.555 198.509 122.822 198.246C126.205 197.548 126.988 193.983 129.02 192.415C130.136 191.554 131.283 191.324 131.7 193.672C131.781 194.705 131.796 195.753 131.871 196.703C131.991 198.197 131.617 198.474 132.884 198.987C134.098 199.478 136.464 199.96 136.87 199.802C137.187 199.678 137.167 197.815 137.107 196.421C136.979 196.41 136.975 196.899 136.909 196.888C136.785 196.871 136.633 196.839 136.453 196.822C136.462 196.075 136.492 195.695 136.656 195.132C136.815 194.588 136.885 194.195 137.214 193.864C137.34 193.736 137.338 192.985 137.283 192.769C136.573 193.213 136.094 193.919 135.838 194.807C135.663 195.411 135.556 195.875 135.462 196.66C134.737 196.521 134.006 196.415 133.728 196.092C133.015 195.268 132.888 194.237 132.632 192.626C132.572 189.794 132.696 189.373 134.171 187.273C134.579 186.692 134.6 185.503 133.59 182.854C133.564 182.803 133.545 182.752 133.528 182.703Z",
    fill: "url(#paint29_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.419 181.059C134.368 182.376 129.845 179.33 123.517 180.494C124.872 176.319 125.656 175.433 127.556 174.212C130.033 172.62 134.205 173.271 135.515 175.465C136.768 177.567 136.265 180.001 135.419 181.059Z",
    fill: "url(#paint30_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.779 199.749C118.406 200.171 117.026 201.527 117.278 202.43C118.644 208 129.012 209.057 135.37 207.717C135.445 207.702 132.895 204.361 131.679 203.966C127.676 204.359 121.014 203.038 119.779 199.749Z",
    fill: "#6AD2A9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.881 251.008C136.46 248.489 139.965 232.054 140.711 229.1C142.203 223.179 143.421 217.021 141.931 213.206C140.157 208 131.933 212.748 130.751 219.759C129.339 228.15 119.33 251.729 135.881 251.008Z",
    fill: "#17ACC8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.951 281.665C136.188 282.828 135.16 282.606 134.957 283.887C135.041 283.936 136.503 284.738 136.727 284.781C137.037 284.843 137.727 284.258 137.768 283.957C137.776 283.887 137.616 282.935 137.616 282.935L136.951 281.665Z",
    fill: "#E7A376"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.19 250.839C153.188 250.327 153.59 249.911 153.413 249.582C153.22 249.225 152.429 249.008 152.09 248.899C151.607 248.745 151 248.837 150.341 249.217L123.504 264.685C121.937 265.588 120.668 267.782 120.674 269.582L120.742 288.775C120.745 289.656 121.052 290.279 121.55 290.58C121.854 290.764 122.711 291.101 123.13 291.029C123.425 290.977 123.26 290.587 123.591 290.397L150.429 274.928C151.998 274.023 153.265 271.829 153.259 270.032L153.19 250.839Z",
    fill: "url(#paint31_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.894 251.093C153.889 249.294 152.613 248.568 151.045 249.471L124.207 264.939C122.64 265.842 121.371 268.038 121.377 269.836L121.446 289.029C121.45 290.826 122.728 291.554 124.295 290.651L151.132 275.182C152.701 274.277 153.968 272.085 153.962 270.286L153.894 251.093Z",
    fill: "url(#paint32_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.259 252.991C152.256 252.254 151.735 251.955 151.092 252.327L144.46 256.126C143.818 256.495 143.299 257.394 143.299 258.132L143.265 265.422C143.267 266.158 143.791 266.457 144.432 266.085L151.064 262.286C151.707 261.915 152.224 261.016 152.224 260.28L152.259 252.991Z",
    fill: "url(#paint33_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.259 264.929C152.259 264.559 151.996 264.414 151.673 264.606L125.036 279.678C124.713 279.87 124.455 280.324 124.455 280.694V281.424C124.457 281.793 124.718 281.938 125.04 281.746L151.677 266.675C152 266.482 152.259 266.028 152.259 265.661V264.929Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.259 269.185C152.259 268.815 151.996 268.67 151.673 268.862L125.036 283.934C124.713 284.126 124.455 284.58 124.455 284.95V285.68C124.457 286.049 124.718 286.194 125.04 286.004L151.677 270.933C152 270.741 152.259 270.286 152.259 269.917V269.185Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.967 271.372C144.433 272.952 145.296 273.688 145.782 274.523C146.352 275.5 146.733 276.036 146.654 276.856C146.431 279.155 146.051 280.903 145.341 281.569C144.057 282.773 138.962 284.344 136.735 284.832C136.974 283.729 137.275 282.516 136.869 281.289C136.534 280.277 135.771 279.451 135.538 278.397C135.271 277.182 136.023 275.774 136.068 273.703L143.967 271.372Z",
    fill: "#E7A376"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.732 284.314C137.962 284.533 137.266 284.713 136.731 284.832C136.971 283.729 137.272 282.516 136.866 281.289C136.53 280.277 135.767 279.451 135.534 278.397C135.267 277.182 136.02 275.774 136.064 273.703L137.774 273.197L137.732 273.509C137.736 275.56 137.582 276.237 137.856 277.065C138.505 279.02 139.106 279.251 139.236 280.437C139.343 281.398 139.206 282.963 138.732 284.314Z",
    fill: "#F0B186"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.165 221.642C144.541 229.136 141.525 240.094 140.542 247.488L143.949 270.438C143.464 274.365 137.031 275.43 135.49 273.804L128.992 248.916C129.289 243.099 131.13 226.73 131.764 221.185C132.194 217.431 134.231 213.117 137.041 211.518C142.878 208.199 147.574 215.149 146.165 221.642Z",
    fill: "url(#paint34_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.739 352.159L303.179 331.366C299.193 329.547 293.489 328.1 289.428 330.211C285.728 332.134 279.633 336.07 276.938 337.605C274.89 338.77 267.784 343.022 272.21 345.425C285.23 352.495 298.114 360.448 311.335 367.63C313.835 368.988 317.492 369.478 321.333 369.16C325.157 368.842 329.076 367.73 332.16 365.939C334.357 364.663 336.518 363.406 338.643 362.17C341.511 360.503 343.03 358.531 343.182 356.708C343.332 354.926 342.186 353.276 339.739 352.159Z",
    fill: "#4AABBE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M281.202 225.078C275.886 222.15 268.754 220.088 265.437 219.187C264.952 219.055 261.468 218.175 260.998 218.015C260.74 217.887 259.573 217.405 259.365 217.294C259.256 219.704 258.483 221.582 257.076 223.051C257.318 223.147 258.589 223.815 258.85 223.928C259.237 224.141 259.784 225.236 260.073 225.567C262.952 228.865 272.176 233.915 279.445 236.688C279.453 236.692 279.462 236.694 279.473 236.696C281.264 237.571 283.914 237.14 285.205 235.518C286.03 234.95 286.829 234.331 287.363 233.983C291.486 231.294 299.178 221.595 305.212 206.225C304.186 205.053 300.817 203.535 300.202 203.3C297.526 202.28 294.925 203.339 293.957 204.152C292.183 205.64 290.131 208.558 288.338 213.471C287.128 216.786 283.79 220.918 281.341 224.85C281.296 224.927 281.249 225.004 281.202 225.078Z",
    fill: "url(#paint35_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.207 235.518C286.032 234.95 286.831 234.331 287.366 233.983C291.488 231.294 299.18 221.595 305.214 206.225C299.114 199.249 290.693 207.601 288.436 213.785C285.513 221.795 282.83 228.598 281.285 237.127C282.839 237.324 284.164 236.826 285.207 235.518Z",
    fill: "#6266D7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.796 214.131L253.721 212.346C253.471 212.064 253.056 211.817 252.661 212.026C251.197 212.799 251.558 215.556 253.475 217.006C251.18 217.087 250.395 217.633 250.284 218.664C250.113 220.28 250.423 226.306 251.462 226.739C252.319 227.095 256.525 227.494 257.322 226.818C257.905 226.323 257.279 225.915 258.061 225.091C258.322 224.818 259.431 224.811 260.265 224.15C261.346 223.29 261.586 220.323 260.844 218.617C260.816 217.582 260.703 216.905 260.355 216.376C259.006 214.308 256.144 216.363 254.796 214.131Z",
    fill: "#FFA698"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.319 218.483C254.762 218.613 254.911 218.811 254.15 218.876C254.334 219.144 255.022 219.371 255.76 219.629C256.621 219.352 256.95 219.307 257.275 219.83C258.224 221.349 257.886 224.549 257.811 225.452C258.162 224.636 260.297 224.801 260.808 223.488C261.173 222.365 261.492 219.601 260.876 219.044C260.34 219.766 259.466 220.039 258.75 219.887C257.44 219.612 255.681 218.4 255.319 218.483Z",
    fill: "url(#paint36_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.477 341.526C323.675 342.245 323.564 342.847 323.919 343.79C324.274 344.736 324.699 345.79 325.086 347.432C325.685 349.967 324.862 353.365 325.667 356.951C326.084 358.386 326.052 359.534 325.097 360.802C324.161 362.044 322.4 364.036 320.106 363.959C319.583 363.942 318.512 363.732 317.685 362.785C316.817 361.79 316.107 360.334 316.238 358.533C316.287 357.85 316.685 355.645 316.618 353.639C316.558 351.882 316.238 350.915 316.276 348.988C316.319 346.951 316.477 344.147 316.507 342.834L323.477 341.526Z",
    fill: "#16193B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.201 331.088C303.865 332.892 304.303 333.664 304.335 336.183C303.927 337.513 302.989 338.053 301.944 338.971L301.206 339.131C299.379 340.117 298.712 343.579 297.017 345.156C295.821 346.268 293.442 346.875 291.08 347.329C288.556 347.816 286.156 347.096 286.814 345.111C288.447 340.185 295.504 334.621 295.667 329.116L303.201 331.088Z",
    fill: "#16193B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M292.608 295.974C292.79 305.413 294.848 323.075 294.534 332.377C296.949 334.796 301.783 334.046 303.354 331.573C304.335 323.013 305.477 310.856 305.59 306.16C305.684 302.252 305.333 298.657 304.333 295.146C305.737 284.819 311.709 270.728 310.288 261.012C309.664 256.745 306.864 252.15 306.047 248.63C299.003 257.296 293.636 253.142 290.721 252.389C290.738 255.383 290.512 254.984 290.608 258.13C290.937 268.773 291.433 280.137 292.016 291.178C291.997 292.83 292.144 294.642 292.608 295.974Z",
    fill: "url(#paint37_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.977 315.112C305.306 311.396 305.541 308.16 305.59 306.16C305.684 302.252 305.333 298.657 304.333 295.146C305.737 284.82 311.709 270.728 310.288 261.012C309.664 256.745 306.864 252.15 306.047 248.63C299.003 257.296 293.636 253.142 290.721 252.391C290.723 252.724 290.721 253.016 290.719 253.274L299.95 260.085L297.676 259.573C297.763 271.838 299.281 283.018 299.509 295.112C301.892 301.97 303.292 307.829 304.938 314.896L304.977 315.112Z",
    fill: "#1E2353"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.296 302.839C309.993 312.277 314.945 335.18 316.125 344.482C319.174 346.174 323.656 345.583 324.733 343.109C324.768 334.552 324.733 319.159 324.092 314.463C323.558 310.555 322.173 304.525 320.609 301.014C321.233 278.963 323.113 272.792 320.13 263.076C318.82 258.809 315.391 254.692 314.011 251.17C312.119 254.068 309.204 258.184 302.955 257.676C302.343 257.627 297.133 253.908 295.412 253.481C297.592 266.6 303.876 283.737 306.932 298.045C307.18 299.697 307.618 301.509 308.296 302.839Z",
    fill: "url(#paint38_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298.554 202.267C297.862 202.353 297.244 202.568 296.605 202.923C291.956 205.501 290.336 213.087 289.588 219.734C288.941 225.499 289.432 230.284 289.616 235.558C289.761 239.768 289.219 243.661 289.409 247.644C289.464 248.824 289.913 250.103 290.035 251.36C290.398 252.258 290.351 253.153 290.338 253.844C292.666 262.707 314.663 263.441 317.864 257.441C317.64 256.551 317.381 255.663 317.3 254.758C319.371 252.875 318.174 248.282 318.501 245.076C318.747 242.668 319.093 240.212 319.805 238.455C322.797 231.095 326.973 225.43 327.803 219.781C328.373 215.889 323.396 211.044 316.83 207.121C310.512 203.343 301.937 201.281 298.554 202.267Z",
    fill: "url(#paint39_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.568 219.936C291.904 222.301 306.299 236.039 322.234 232.508L322.069 231.426C305.273 235.146 290.107 218.85 290.062 218.803L289.651 219.196C289.63 219.377 289.609 219.556 289.589 219.736C289.581 219.802 289.575 219.868 289.568 219.936Z",
    fill: "#9789E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.308 228.461C293.249 232.169 305.502 242.374 319.211 240.393C319.305 239.987 319.41 239.599 319.527 239.234C304.927 241.605 291.839 229.403 289.272 226.835C289.278 227.379 289.291 227.921 289.308 228.461Z",
    fill: "#9789E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.889 238.252L317.057 232.367L313.262 238.762L309.992 230.976L305.497 236.98L303.172 228.617L298.425 233.733L296.264 224.216L292.723 229.554L289.752 218.387C289.694 218.839 289.639 219.29 289.589 219.736C289.572 219.896 289.555 220.054 289.538 220.212L292.445 231.138L295.948 225.859L298.042 235.089L302.834 229.926L305.204 238.446L309.808 232.295L313.142 240.231L316.976 233.77L319.56 239.14C319.637 238.903 319.72 238.675 319.808 238.457C319.834 238.387 319.862 238.318 319.889 238.252Z",
    fill: "#9789E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M316.796 237.221C316.486 237.242 316.236 237.522 316.236 237.842C316.236 238.162 316.486 238.406 316.796 238.384C317.106 238.363 317.356 238.083 317.356 237.763C317.353 237.443 317.103 237.2 316.796 237.221Z",
    fill: "#9789E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.419 233.8C313.109 233.821 312.859 234.101 312.859 234.421C312.859 234.741 313.109 234.984 313.419 234.963C313.729 234.942 313.979 234.662 313.979 234.342C313.979 234.019 313.729 233.778 313.419 233.8Z",
    fill: "#9789E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.475 236.335C309.166 236.357 308.916 236.636 308.916 236.957C308.916 237.277 309.166 237.52 309.475 237.499C309.785 237.477 310.035 237.198 310.035 236.878C310.035 236.555 309.785 236.314 309.475 236.335Z",
    fill: "#9789E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.137 231.921C305.827 231.943 305.577 232.222 305.577 232.542C305.577 232.863 305.827 233.106 306.137 233.085C306.447 233.063 306.697 232.784 306.697 232.463C306.697 232.141 306.447 231.9 306.137 231.921Z",
    fill: "#9789E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.954 233.576C301.645 233.597 301.395 233.876 301.395 234.197C301.395 234.517 301.645 234.76 301.954 234.739C302.264 234.717 302.514 234.438 302.514 234.118C302.514 233.795 302.264 233.554 301.954 233.576Z",
    fill: "#9789E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299.46 228.698C299.15 228.72 298.9 228.999 298.9 229.319C298.9 229.64 299.15 229.883 299.46 229.862C299.77 229.84 300.02 229.561 300.02 229.24C300.02 228.918 299.77 228.677 299.46 228.698Z",
    fill: "#9789E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M295.241 229.734C294.931 229.755 294.681 230.034 294.681 230.355C294.681 230.675 294.931 230.918 295.241 230.897C295.551 230.875 295.801 230.596 295.801 230.276C295.801 229.953 295.551 229.71 295.241 229.734Z",
    fill: "#9789E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.004 224.434C292.694 224.455 292.444 224.735 292.444 225.055C292.444 225.375 292.694 225.618 293.004 225.597C293.314 225.576 293.564 225.296 293.564 224.976C293.564 224.654 293.314 224.412 293.004 224.434Z",
    fill: "#9789E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.409 224.993C289.36 224.997 289.313 225.006 289.268 225.021C289.263 225.398 289.261 225.772 289.263 226.145C289.31 226.154 289.357 226.158 289.409 226.154C289.719 226.133 289.969 225.853 289.969 225.533C289.969 225.213 289.719 224.972 289.409 224.993Z",
    fill: "#9789E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320.536 233.913C320.226 233.934 319.976 234.214 319.976 234.534C319.976 234.854 320.226 235.097 320.536 235.076C320.846 235.055 321.096 234.775 321.096 234.455C321.096 234.135 320.846 233.891 320.536 233.913Z",
    fill: "#9789E9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.099 222.826C316.261 227.366 317.321 235.055 319.561 239.119C320.653 236.34 321.589 234.248 323.079 231.659C322.951 231.309 318.136 217.213 317.099 222.826Z",
    fill: "#6266D7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.037 251.571C290.48 252.581 290.347 253.206 290.336 253.844C292.664 262.706 314.66 263.441 317.862 257.441C317.638 256.551 317.379 255.663 317.298 254.758C319.369 252.875 318.172 248.282 318.499 245.076C318.745 242.668 319.091 240.212 319.803 238.455C322.214 232.523 325.394 227.693 326.971 223.085L323.836 220.203L317.527 218.297C316.199 221.561 315.535 224.852 315.086 228.163C314.53 232.273 314.306 236.414 313.564 240.574C312.679 251.701 310.972 259.206 290.037 251.571Z",
    fill: "#6266D7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.604 264.948C303.506 265.02 302.946 265.518 302.416 265.661C302.224 265.712 302.002 265.654 301.856 265.603L285.564 254.704L282.884 252.312L263.826 236.609C263.317 236.16 262.24 235.503 262.159 235.23C262.133 235.14 263.255 234.585 263.298 234.54C263.432 234.397 263.965 234.54 265.08 235.21L281.561 244.822C282.629 245.458 282.937 245.612 283.296 246.004L303.483 264.152C303.756 264.384 303.861 264.756 303.604 264.948Z",
    fill: "#D8FFF7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.517 264.933C302.581 265.133 302.97 266.03 301.55 265.524L284.465 255.362L281.785 252.969L263.14 236.579C261.915 235.503 261.488 234.374 263.98 235.868L280.46 245.479C281.529 246.115 281.836 246.269 282.195 246.662L302.517 264.933Z",
    fill: "#9FD2FB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.323 252.169C306.877 252.444 306.374 252.67 305.861 252.877C305.857 252.835 305.851 252.79 305.842 252.747C305.705 252.871 305.547 252.976 305.378 253.067C305.086 253.18 304.795 253.289 304.513 253.398C303.705 253.618 302.839 253.663 302.356 253.74C301.501 253.874 299.479 254.169 298.616 254.382C297.49 254.66 296.596 255.676 295.034 256.559L296.744 258.096C296.374 258.269 296.011 258.363 295.637 258.324C294.081 258.169 290.091 256.179 290.253 256.975C290.368 257.543 291.443 259.547 291.922 260.16C292.905 261.415 293.925 262.19 295.438 263.15C296.953 264.111 298.601 265.082 299.621 265.394C300.747 265.737 304.496 263.076 305.197 262.239C307.432 259.569 306.539 258.205 308.781 257.136L307.323 252.169Z",
    fill: "url(#paint40_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M328.345 218.246C329.891 225.006 328.882 235.981 329.591 243.896C329.643 244.476 329.609 244.982 329.502 245.428C329.497 245.537 329.489 245.646 329.474 245.75C329.335 247.492 328.001 248.551 326.375 249.603C322.203 252.305 318.753 255.742 311.273 258.107C310.713 258.284 309.563 258.079 308.879 257.989C308.413 258.13 307.804 258.478 307.308 258.621C307.39 257.052 305.564 253.906 304.167 253.362C304.652 253.102 305.233 252.664 305.755 252.348C306.037 251.799 306.31 251.366 306.727 250.973C309.337 248.512 315.02 244.348 319.315 241.943C318.749 239.977 318.371 237.951 317.988 236.419C317.182 233.202 316.59 229.979 316.15 226.895C315.975 225.661 315.853 225.038 315.706 223.78C314.626 214.451 326.471 210.045 328.345 218.246Z",
    fill: "url(#paint41_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.734 206.568C301.668 206.214 301.583 205.86 301.506 205.48C301.29 204.395 301.572 202.289 301.281 199.804L310.702 195.83C310.858 201.113 311.726 202.201 312.699 206.506C312.594 210.739 302.068 212.632 301.848 207.661C301.83 207.296 301.801 206.927 301.734 206.568Z",
    fill: "#FFA698"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.734 206.568C301.668 206.214 301.582 205.86 301.506 205.48C301.29 204.395 301.572 202.289 301.281 199.804L310.702 195.83C310.739 197.029 310.809 198.018 310.912 198.876C311.247 202.374 307.89 208.468 301.848 207.659C301.83 207.296 301.801 206.927 301.734 206.568Z",
    fill: "url(#paint42_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M301.194 206.333C302.35 205.571 305.509 203.655 306.543 202.897C308.809 201.236 308.533 199.121 309.189 195.804C311.307 194.293 312.019 193.093 312.207 191.738C312.656 188.519 310.82 185.051 308.36 183.155C306.208 181.499 303.735 181.036 300.952 181.644C295.547 182.827 293.32 186.91 293.036 191.58C293.012 191.979 293.063 192.342 293.187 192.739C293.48 193.678 293.553 193.815 293.688 194.472C293.972 195.858 293.036 196.359 293.41 198.08C293.918 200.421 295.863 204.987 296.658 205.751C297.27 206.338 299.999 206.528 301.194 206.333Z",
    fill: "#FFA698"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M293.294 189.544C293.162 190.203 293.076 190.884 293.034 191.578C293.01 191.977 293.061 192.34 293.185 192.737C293.478 193.676 293.551 193.813 293.685 194.47C293.97 195.855 293.034 196.357 293.408 198.077C293.655 199.215 294.241 200.88 294.872 202.378C298.351 205.021 301.394 201.793 301.86 201.194C304.04 198.385 304.209 194.184 302.559 190.259C300.048 191.104 295.942 190.938 293.294 189.544Z",
    fill: "url(#paint43_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.72 190.214C313.577 191.998 312.177 196.583 311.117 198.284C310.018 200.045 310.497 197.887 309.92 196.681C309.475 195.755 308.037 195.646 307.601 194.69C307.387 195.503 307.103 196.293 306.579 196.579C306.246 196.76 305.571 197.01 305.543 196.052C305.451 192.739 303.882 192.509 304.376 190.524C304.748 189.036 304.658 188.396 304.293 187.86C303.211 188.011 302.514 189.119 301.245 189.666C300.362 190.045 296.472 190.457 293.707 188.95C291.033 187.493 290.785 184.242 293.029 182.152C294.28 180.989 295.679 180.694 297.641 179.384C301.384 176.882 306.058 177.772 308.582 180.541C313.506 181.535 314.043 186.225 313.72 190.214Z",
    fill: "#562E65"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.492 193.006C310.531 192.082 310.784 194.513 310.602 196.02C310.476 197.055 309.632 197.061 309.407 197.892C309.138 198.88 308.441 199.396 307.806 199.441C306.52 199.531 307.127 197.55 307.206 196.777C306.932 195.554 307.197 193.593 308.492 193.006Z",
    fill: "#FFA698"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.901 186.259C303.1 187.642 301.318 189.269 298.811 189.405C296.487 189.531 293.337 188.985 292.174 186.165C291.766 185.175 292.256 183.412 293.395 182.686C294.173 182.191 295.167 182.255 296.182 182.699C297.9 183.452 299.332 185.369 300.561 185.841C301.728 186.289 302.88 186.112 302.901 186.259Z",
    fill: "url(#paint44_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 204.05,
    y1: 112.819,
    x2: 205.644,
    y2: 136.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#965CF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8ADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 0,
    y1: 336.189,
    x2: 29.5241,
    y2: 336.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5966F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 220.075,
    y1: 364.081,
    x2: 184.381,
    y2: 336.159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#965CF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8ADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 417.873,
    y1: 43.7798,
    x2: 439.831,
    y2: 43.7798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5966F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 332.37,
    y1: 27.4607,
    x2: 351.309,
    y2: 9.5241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA5DB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEBFBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 401.182,
    y1: 164.677,
    x2: 290.647,
    y2: 222.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAEFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 243.45,
    y1: 96.7563,
    x2: 161.343,
    y2: 205.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1E8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAEFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 375.636,
    y1: 121.048,
    x2: 396.864,
    y2: 89.7617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6AFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FB0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 330.649,
    y1: 117.832,
    x2: 375.582,
    y2: 98.0473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6AFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FB0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 313.825,
    y1: 93.5116,
    x2: 290.508,
    y2: 145.779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C8EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CFDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 237.717,
    y1: 215.795,
    x2: 215.263,
    y2: 174.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#965CF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8ADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 209.023,
    y1: 130.345,
    x2: 209.173,
    y2: 123.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6AFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FB0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 241.782,
    y1: 179.007,
    x2: 230.715,
    y2: 196.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E46AA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D985B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9B29D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 243.337,
    y1: 181.73,
    x2: 213.247,
    y2: 187.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E46AA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D985B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9B29D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 276.454,
    y1: 254.633,
    x2: 269.401,
    y2: 178.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6AFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FB0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 252.972,
    y1: 254.612,
    x2: 189.354,
    y2: 182.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#965CF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8ADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 406.778,
    y1: 319.453,
    x2: 367.325,
    y2: 272.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA5DB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEBFBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 412.304,
    y1: 346.128,
    x2: 333.839,
    y2: 287.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA5DB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEBFBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 370.114,
    y1: 324.508,
    x2: 368.913,
    y2: 310.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#965CF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8ADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 420.662,
    y1: 182.439,
    x2: 428.996,
    y2: 174.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6AFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FB0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 398.151,
    y1: 187.502,
    x2: 400.697,
    y2: 185.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6AFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FB0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 101.754,
    y1: 209.908,
    x2: 114.297,
    y2: 241.339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94E69A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17ADC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 124.451,
    y1: 272.142,
    x2: 113.582,
    y2: 318.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3773C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#214075"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 126.937,
    y1: 332.739,
    x2: 123.001,
    y2: 338.393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3773C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#214075"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 132.477,
    y1: 277.634,
    x2: 97.6743,
    y2: 322.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3773C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#214075"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 106.742,
    y1: 344.258,
    x2: 100.784,
    y2: 345.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3773C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#214075"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 127.207,
    y1: 218.507,
    x2: 119.059,
    y2: 250.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94E69A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17ADC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 130.1,
    y1: 184.061,
    x2: 123.148,
    y2: 195.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3701,
    stopColor: "#FF9584"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 128.562,
    y1: 183.02,
    x2: 124.702,
    y2: 194.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB89E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 129.072,
    y1: 180.814,
    x2: 124.059,
    y2: 197.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A2D68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22043D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: 136.123,
    y1: 174.841,
    x2: 128.61,
    y2: 179.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A4791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#562E65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x1: 135.914,
    y1: 261.288,
    x2: 139.522,
    y2: 285.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4E0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E8F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear",
    x1: 139.76,
    y1: 272.622,
    x2: 129.817,
    y2: 260.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6AFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FB0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear",
    x1: 146.935,
    y1: 257.563,
    x2: 148.531,
    y2: 260.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4E0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E8F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear",
    x1: 141.068,
    y1: 216.059,
    x2: 135.811,
    y2: 264.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94E69A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17ADC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear",
    x1: 279.284,
    y1: 218.141,
    x2: 273.099,
    y2: 229.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F73F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#565DD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear",
    x1: 256.947,
    y1: 222.202,
    x2: 259.122,
    y2: 218.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear",
    x1: 293.665,
    y1: 268.157,
    x2: 307.944,
    y2: 314.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A407F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B2153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear",
    x1: 301.947,
    y1: 271.001,
    x2: 328.516,
    y2: 324.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A407F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B2153"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear",
    x1: 309.846,
    y1: 213.317,
    x2: 301.564,
    y2: 255.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F73F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#565DD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear",
    x1: 299.792,
    y1: 258.001,
    x2: 300.628,
    y2: 260.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB89E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear",
    x1: 323.95,
    y1: 214.959,
    x2: 314.512,
    y2: 260.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F73F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#565DD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear",
    x1: 305.548,
    y1: 200.931,
    x2: 307.989,
    y2: 203.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear",
    x1: 297.317,
    y1: 192.879,
    x2: 300.342,
    y2: 200.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB89E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear",
    x1: 295.81,
    y1: 187.214,
    x2: 298.042,
    y2: 185.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A4791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#562E65"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 475,
    height: 401,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftDevelopmentCase2);
export default __webpack_public_path__ + "static/media/soft_development_case_2.0498d7189a645fccb971070cf3093724.svg";
export { ForwardRef as ReactComponent };